export let chatData = {};


export const filterFriendsData = (friends) => {
  friends.map(friend => {
    chatData[friend.id] = {
      username: friend.username,
      avatar_image_url: friend.avatar_image_url,
      userId: friend.id,
      remote_id: 1,
    }
  })
}
export const filterChatMessageData = (messages) => {
  messages.map(message => {
    chatData[message.sender_id] = {
      username: message.username,
      avatar_image_url: message.avatar_image_url,
      userId: message.sender_id,
    }
  })
  return messages;
}
export const filterSocketItems = (socketItems) => {
  Object.keys(socketItems).forEach(key => {
    const item = socketItems[key];
    chatData[item.userId] = {
      username: item.userName,
      avatar_image_url: item.userAvatarUrl,
      userId: item.userId,
    }
  })
}
